'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _availability = require('availability');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    /**
     * Returns:
     *      status, until, reason, comment, isPast, isEarly, isLate
     */
    olrAvailable: function olrAvailable(_ref) {
        var cal = _ref.cal,
            reservationTimeCal = _ref.reservationTimeCal,
            restaurant = _ref.restaurant;


        var diff = reservationTimeCal.diff(cal);
        var futureDelayMins = _lodash2.default.get(restaurant, 'reservations.futureDelayMins', {});

        var isEarly = function () {
            if (!futureDelayMins.min) return false;
            return Math.ceil(diff / 60000) < futureDelayMins.min;
        }();

        var isLate = function () {
            if (!futureDelayMins.max) return false;
            return Math.ceil(diff / 60000) > futureDelayMins.max;
        }();

        var openTimes = _lodash2.default.get(restaurant, 'openTimes', {});
        var olrTimes = _lodash2.default.get(restaurant, 'reservations.availability', {});

        var it = new _availability.ConjunctiveTimeWindowsIterator({
            iterators: [olrTimes, openTimes].map(function (availability) {
                return new _availability.AvailabilityIterator({ availability: availability, cal: cal });
            }),
            cal: reservationTimeCal.clone()
        });

        return _lodash2.default.extend({}, it.next(), { isPast: diff < 0, isEarly: isEarly, isLate: isLate });
    }
};